const LogUser = {
    insertLog: "/api/LogUser/insertLog"
};

export default LogUser;
